import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'How long does the Jealous Neighbor Package take?',
  a: 'Most homes are completed in just a few hours. Our professional equipment and proven system allow us to deliver a full front exterior refresh efficiently without cutting corners.'
}, {
  q: 'Will power washing damage my surfaces?',
  a: 'No. We use the proper pressure and soft wash techniques for each surface. Our commercial-grade equipment and experience ensure a deep clean without causing damage.'
}, {
  q: 'Do I need to be home during the service?',
  a: 'Not necessarily. As long as we have access to the areas being cleaned and a water source, we can complete the service and notify you once everything looks spotless.'
}, {
  q: "What if I'm not satisfied with the results?",
  a: "We stand behind our work with guaranteed results. If you're not 100% happy, we'll come back and make it right — no questions asked."
}];
function FAQItem({
  q,
  a,
  isOpen,
  onClick
}: {
  q: string;
  a: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="bg-white rounded-[16px] mb-4 overflow-hidden transition-all" style={{
    boxShadow: '0 4px 16px rgba(0,0,0,0.04)'
  }} data-id="element-237">
      <button className="w-full flex items-center justify-between p-6 text-left" onClick={onClick} data-id="element-238">
        <span className="pr-4" style={{
        color: '#1F2937',
        fontFamily: '"Plus Jakarta Sans", sans-serif',
        fontWeight: 700,
        fontSize: '16px'
      }} data-id="element-239">
          {q}
        </span>
        <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all" style={{
        backgroundColor: isOpen ? '#3B8AC4' : '#F3F4F6'
      }} data-id="element-240">
          <ChevronDownIcon className={`w-4 h-4 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} style={{
          color: isOpen ? '#FFFFFF' : '#3B8AC4'
        }} data-id="element-241" />
        </div>
      </button>
      <div className="overflow-hidden transition-all duration-300" style={{
      maxHeight: isOpen ? '300px' : '0px',
      opacity: isOpen ? 1 : 0
    }} data-id="element-242">
        <p className="px-6 pb-6" style={{
        color: '#4F5B69',
        fontFamily: '"Plus Jakarta Sans", sans-serif',
        fontSize: '15px',
        lineHeight: 1.6
      }} data-id="element-243">
          {a}
        </p>
      </div>
    </div>;
}
export function JealousFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full py-24 px-4" style={{
    backgroundColor: '#EDF5FB'
  }} data-id="element-244">
      <div className="max-w-[700px] mx-auto" data-id="element-245">
        <div className="text-center mb-12" data-id="element-246">
          <p className="mb-3" style={{
          color: '#3B8AC4',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 700,
          fontSize: '13px',
          letterSpacing: '1px',
          textTransform: 'uppercase'
        }} data-id="element-247">
            FAQ
          </p>
          <h2 className="mb-4" style={{
          color: '#1F2937',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 800,
          fontSize: 'clamp(28px, 4vw, 36px)',
          letterSpacing: '-0.02em',
          lineHeight: 1.2
        }} data-id="element-248">
            Frequently Asked Questions
          </h2>
          <p style={{
          color: '#4F5B69',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontSize: '16px'
        }} data-id="element-249">
            Everything you need to know before booking.
          </p>
        </div>

        <div className="flex flex-col" data-id="element-250">
          {faqs.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} isOpen={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-251" />)}
        </div>
      </div>
    </section>;
}